import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { SidebarItem, SidebarSection } from '@app/app/shared/models/sidebar/sidebar.model';
import { LucideChevronDown, LucidePlus } from '@lucide/angular';

@Component({
  selector: 'ptl-admin-sidebar-section',
  templateUrl: './admin-sidebar-section.component.html',
  styleUrls: ['./admin-sidebar-section.component.scss'],
})
export class AdminSidebarSectionComponent {
  @Input() section: SidebarSection;
  @Output() addContent = new EventEmitter<void>();
  @Output() itemClick = new EventEmitter<{ item: SidebarItem; event: Event }>();

  protected readonly LucideChevronDown = LucideChevronDown;
  protected readonly LucidePlus = LucidePlus;

  constructor(private router: Router) {}

  toggle(): void {
    this.section.expanded = !this.section.expanded;
  }

  isRouteActive(route: string): boolean {
    return this.router.isActive(route, { paths: 'subset', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' });
  }

  isSectionActive(): boolean {
    return this.section.items.some((item) => {
      const route = item.url || item.uri;
      if (route && this.isRouteActive(route)) return true;
      return (
        item.children?.some((child) => {
          const childRoute = child.url || child.uri;
          return childRoute ? this.isRouteActive(childRoute) : false;
        }) ?? false
      );
    });
  }

  toggleItemExpand(event: Event, item: SidebarItem): void {
    event.preventDefault();
    event.stopPropagation();
    item.expanded = !item.expanded;
  }

  onAddContent(event: Event): void {
    event.stopPropagation();
    this.addContent.emit();
  }

  onItemClick(event: Event, item: SidebarItem): void {
    this.itemClick.emit({ item, event });
  }
}
